import React, { useEffect, useState, useRef } from "react";
import * as singleSpa from "single-spa";
import dayjs from "dayjs";
import md5 from "md5";
const SystemJs = window["System"];
import style from "./style.less";
import {
  useSafeState,
  useUpdateEffect,
  useAsyncEffect,
  useMount,
  useUnmount,
} from "ahooks";

import AntdIcon from "@ant-design/icons";
import loadingSvg from "@/svg/loading.svg";
import useSearchJson from "@/hooks/useSearchJson.js";

async function getMainfest(url) {
  try {
    let res = await fetch(url, {});
    let json = await res.json();
    return json;
  } catch (e) {
    console.error("getMainfest", e);
    return null;
  }
}

export default (props = {}) => {
  const [mainfest, setMainfest] = useSafeState();
  const { appAssetDir, msMountDomId } = props;
  const { refresh = dayjs().format("YYYYMMDD") } = useSearchJson();
  useMount(async () => {
    let url = `${window["Web_Host"]}/${appAssetDir}/manifest.json?r=${refresh}`;
    setMainfest(await getMainfest(url));
  });

  if (mainfest === undefined) {
    return (
      <div styleName="msg">
        <AntdIcon
          component={loadingSvg}
          spin={true}
          style={{ fontSize: "2.5rem", color: "lawngreen" }}
        />
        <span>Loading</span>
      </div>
    );
  }

  if (mainfest === null) {
    return (
      <div styleName="msg">
        <span>mainfest === null</span>
      </div>
    );
  }

  const indexJs = mainfest["index.js"];
  if (!indexJs) {
    return <div styleName="msg">!indexJs</div>;
  }

  const createDt = mainfest["createDt"]
    ? dayjs(mainfest["createDt"]).format("YYYYMMDDHHmmss")
    : dayjs().format("YYYYMMDDHHmmss");

  const domElement = document.getElementById(msMountDomId);
  if (!domElement) {
    return <div styleName="msg">!document.getElementById(msMountDomId)</div>;
  }

  const nextProps = {
    ...props,
    indexJs,
    createDt,
    appAssetDir,
    domElement,
    mainfestData: mainfest,
  };
  return <RegisterModule {...nextProps} />;
};

const RegisterModule = (props = {}) => {
  const { indexJs, createDt, appAssetDir, domElement, mainfestData } = props;
  const [parcel, setParcel] = useSafeState();
  useMount(() => {
    const url = `${window["Web_Host"]}/${indexJs}?dt=${md5(createDt)}`;
    try {
      const newParcel = singleSpa.mountRootParcel(SystemJs.import(url), {
        ...props,
        domElement, //注意：是这必须属性，不然single-sap会报错并中断程序
        mainfestData,
      });
      setParcel(newParcel);
    } catch (err) {
      console.log("singleSpa.mountRootParcel.err", err);
    }
  });
  useUnmount(() => {
    parcel?.unmount();
  });
  return <></>;
};
